import { EmptyState, EmptyStateProps, Table } from '@dixa/lib-shared-habla';

type ConversationsTableEmptyRowProps = Partial<EmptyStateProps>;

export const ConversationsTableEmptyRow = (
  props: ConversationsTableEmptyRowProps,
): JSX.Element => {
  return (
    <Table.Tr>
      <Table.Td colSpan={100}>
        <EmptyState
          title="No conversations match the criteria"
          description="Try changing or resetting filters"
          size="large"
          icon="url-trigger"
          {...props}
        />
      </Table.Td>
    </Table.Tr>
  );
};
